module.exports = __webpack_public_path__ + "img/spiritualityIco.c3372851.svg";